import { TestableComponent } from 'common/interfaces';
import { getClassName } from 'common/utils';
import React from 'react';

interface DescriptionTitleProps extends TestableComponent {
  lines?: number;
  children: string;
  large?: boolean;
  fontWeightNormal?: boolean;
}

function DescriptionTitle({
  lines,
  children,
  large,
  fontWeightNormal,
  testId
}: DescriptionTitleProps) {
  return (
    <span
      data-test-id={testId || 'description-title'}
      className={getClassName('description-title', { large, 'weight-normal': fontWeightNormal })}
      style={{ WebkitLineClamp: lines }}
    >
      {children}
    </span>
  );
}

export default React.memo(DescriptionTitle);
